import { useEffect, useState } from "react";
import { gql, useQuery, useMutation } from "@apollo/client";
import { captureException } from "@sentry/react";
import { useNavigate } from "react-router-dom";

import { PAGES_DOMAIN_URL } from "constants";
import LoadingBox from "components/other/LoadingBox";
import BoxLoadingSpinner from "components/other/BoxLoadingSpinner";
import AutoresponderData from "./AutoresponderData";

export default ({ autoresponderId }) => {
  const navigate = useNavigate();

  const [loadingStatusToggle, setLoadingStatusToggle] = useState(false);

  // Fetch data
  const AUTORESPONDER_DATA = gql`
    query GetAutoresponderData($responderId: ID!) {
      responderData(responderId: $responderId) {
        responder {
          id
          name
          lists {
            id
            name
          }
          status
        }
        last24HoursLeads
        prev24HoursLeads
        last7DaysLeads
        prev7DaysLeads
        allLeads
        last24HoursSent
        prev24HoursSent
        last7DaysSent
        prev7DaysSent
        allSent
      }
    }
  `;

  const { data, error } = useQuery(AUTORESPONDER_DATA, {
    variables: {
      responderId: autoresponderId,
    },
    skip: !autoresponderId,
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("error fetching autoresponder data", error);
    captureException(error);
  }

  useEffect(() => {
    if (data) {
      if (!data.responderData.responder) navigate("/autoresponders");
    }
  }, [data]);

  // handle Status toggle
  const CHANGE_RESPONDER_STATUS = gql`
    mutation ChangeResponderStatus($responderId: ID!) {
      changeResponderStatus(responderId: $responderId) {
        id
        status
      }
    }
  `;

  const [changeResponderStatus] = useMutation(CHANGE_RESPONDER_STATUS);

  const onStatusToggleClick = async () => {
    try {
      if (!data) return;

      setLoadingStatusToggle(true);

      await changeResponderStatus({
        variables: {
          responderId: autoresponderId,
        },
      });

      setLoadingStatusToggle(false);
    } catch (error) {
      console.log("error onStatusToggleClick", error);
      captureException(error);
      setLoadingStatusToggle(false);
      return;
    }
  };

  console.log("data", data);

  return (
    <>
      {!data && (
        <LoadingBox>
          <BoxLoadingSpinner height="280px" />
        </LoadingBox>
      )}
      {data?.responderData.responder && (
        <AutoresponderData
          data={data}
          onStatusToggleClick={onStatusToggleClick}
          loadingStatusToggle={loadingStatusToggle}
        />
      )}
    </>
  );
};
